import EasyPassClient from './EasyPassClient';
import SearchServiceClient from './SearchServiceClient';

class FilterClient {
  constructor(user) {
    this.easyPassClient = new EasyPassClient(user);
    this.searchServiceClient = new SearchServiceClient();
    this.easyPassRootUri = 'api/acvapi/v3';
    this.rootUri = 'filters';
    this.customHeaders = {
      'json-naming-strategy': 'camel',
    };
    this.conditionOptions = null;
  }

  searchAutocomplete(params) {
    return this.easyPassClient.get(`${this.easyPassRootUri}/${this.rootUri}/textsearch/autocomplete`, params);
  }

  searchHistory() {
    const params = {
      count: 20,
    };

    return this.easyPassClient.get(`${this.easyPassRootUri}/${this.rootUri}/textsearch/history`, params);
  }

  getFiltersAuctionsSearchFilters(searchTerms, useSearchService = false) {
    if (useSearchService) {
      return this.searchServiceClient.getFilters(searchTerms);
    }
    return this.easyPassClient.get('query-engine/auctions/buying/search/filters', { query: searchTerms }, this.customHeaders);
  }

  getFiltersAuctionsSearchSuggestions(searchTerms) {
    return this.searchServiceClient.getSearchSuggestions(searchTerms);
  }

  getFilterOptions(useSearchService = false) {
    if (useSearchService) {
      return this.searchServiceClient.getFilterOptions();
    }
    return this.easyPassClient.get('query-engine/auctions/buying/filter_options', null, this.customHeaders);
  }

  getTrimOptions(makes, models, useSearchService = false) {
    const params = new URLSearchParams([
      ...makes.map((make) => ['make', make]),
      ...models.map((model) => ['model', model]),
    ]);
    if (useSearchService) {
      return this.searchServiceClient.getTrimOptions(params);
    }
    return this.easyPassClient.get('query-engine/auctions/buying/trim_options', params, this.customHeaders);
  }

  async getConditionOptions(useSearchService = false) {
    // this response requires a code change and a release to alter, so it's pretty safe to store it
    if (this.conditionOptions === null) {
      if (useSearchService) {
        this.conditionOptions = await this.searchServiceClient.getConditionOptions();
      } else {
        this.conditionOptions = await this.easyPassClient.get('query-engine/auctions/buying/condition_options', null, this.customHeaders);
      }
    }

    // clone the response so it doesn't get clobbered
    return JSON.parse(JSON.stringify(this.conditionOptions));
  }

  saveRecentSearch(filters, useSearchService = false) {
    if (useSearchService) {
      return this.searchServiceClient.saveRecentSearch(filters);
    }

    return this.easyPassClient.post('query-engine/auctions/buying/search/recent', { filters }, this.customHeaders);
  }
}

export default FilterClient;
